<svelte:options runes={true} />

<script lang="ts">
  import { ColorMode, ColorModePreference } from '@color';
  import { localeManager, prefs } from '@reactive';
  import * as Shoelace from '@shoelace-style/shoelace';
  import type { MenuSelectEventDetail } from '@shoelace-style/shoelace/dist/components/menu/menu.js';
  import { StringId } from '@strings';
  import { APP_ICON_MOON, APP_ICON_SUN, SlFontSize, type AppIcon } from '@ui';
  import Icon from './Icon.svelte';

  let lightMenuItem: Shoelace.SlMenuItem;
  let darkMenuItem: Shoelace.SlMenuItem;
  let systemMenuItem: Shoelace.SlMenuItem;

  let lightMenuItemChecked = $derived(
    prefs.colorModePreference === ColorModePreference.LIGHT
  );
  let darkMenuItemChecked = $derived(
    prefs.colorModePreference === ColorModePreference.DARK
  );
  let systemMenuItemChecked = $derived(
    prefs.colorModePreference === ColorModePreference.SYSTEM
  );

  $effect(() => {
    lightMenuItem.checked = lightMenuItemChecked;
    darkMenuItem.checked = darkMenuItemChecked;
    systemMenuItem.checked = systemMenuItemChecked;
  });

  function handleSelect(event: CustomEvent<MenuSelectEventDetail>) {
    const value = event.detail.item.value;
    prefs.colorModePreference = value as ColorModePreference;
  }

  let currentIcon = $derived.by<AppIcon>(() => {
    switch (prefs.colorMode) {
      case ColorMode.LIGHT:
        return APP_ICON_SUN;
      case ColorMode.DARK:
        return APP_ICON_MOON;
    }
  });

  function _icon(): AppIcon {
    return currentIcon;
  }
</script>

<div class="dropdown-selection">
  <sl-dropdown>
    <sl-button slot="trigger" caret size="small">
      {#if prefs.colorMode === ColorMode.LIGHT}
        <Icon icon={APP_ICON_SUN} inline size={SlFontSize.LG} />
      {:else}
        <Icon icon={APP_ICON_MOON} inline size={SlFontSize.LG} />
      {/if}
    </sl-button>
    <sl-menu onsl-select={handleSelect} value={prefs.colorModePreference}>
      <sl-menu-item
        bind:this={lightMenuItem}
        type="checkbox"
        value={ColorModePreference.LIGHT}
      >
        <Icon icon={APP_ICON_SUN} inline size={SlFontSize.LG} />
        {localeManager.localizedString(StringId.COLOR_MODE_LIGHT)}
      </sl-menu-item>
      <sl-menu-item
        bind:this={darkMenuItem}
        type="checkbox"
        value={ColorModePreference.DARK}
      >
        <Icon icon={APP_ICON_MOON} inline size={SlFontSize.LG} />
        {localeManager.localizedString(StringId.COLOR_MODE_DARK)}
      </sl-menu-item>
      <sl-divider></sl-divider>
      <sl-menu-item
        bind:this={systemMenuItem}
        type="checkbox"
        value={ColorModePreference.SYSTEM}
      >
        {localeManager.localizedString(StringId.COLOR_MODE_SYSTEM)}
      </sl-menu-item>
    </sl-menu>
  </sl-dropdown>
</div>
